// extracted by mini-css-extract-plugin
export default {"logoS":"screen and (max-width: 1122px)","logo":"Logo_logo__gA4ON"};